import React, {useEffect, useState} from 'react';
import {Grid, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {useIntl} from "react-intl";
// import Cards from "../Card/Cards";
import {useLanguage} from "../../LanguageContext";

const Gallery = () => {


    const {locale, /*changeLocale*/} = useLanguage();

    const {$t} = useIntl();
    let variant = 'subtitle2';

    const theme = useTheme();

    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isMd = useMediaQuery(theme.breakpoints.up('md'));


    if (isXs) {
        variant = 'subtitle2';
    } else if (isMd) {
        variant = 'h2';
    }



    const [item, setItem] = useState(null);
    const [items, setItems] = useState([]);

    useEffect(() => {
        fetch("https://api.altynlogistics.com/api/gallery/list")
            .then(p => p.json())
            .then(p => {
                // for (let i = 0; i < p.length; i++) {
                //     p[i].image = "/news/" + p[i].id + ".jpg"  + "?v=" + Date.now();
                //     p[i].link = "/news-item/" + p[i].id + "/" + p[i].title.replaceAll(' ','-');
                // }
                setItems(p);


            });
    }, []);

    return (
        <Grid dir={locale === 'fa' ? 'rtl' : 'ltr'}>
            <Grid mt={{xs: '88px', md: '192px'}} px={{xs: '20px', md: '120px', lg: '180px'}}>
                <Typography variant={variant} fontWeight={900} pb={{xs: '5px', md: '10px'}}>
                    {item != null && <>{$t({id: 'galleryTitle'})} {item.name}</>}

                    {item == null && <>Gallery</>}
                </Typography>
                <hr />
                <Grid display={'flex'} flexWrap={'wrap'} alignItems={'center'} justifyContent={'space-between'}
                    gap={{xs: '24px', md: '56px'}} pb={{xs: '32px', md: '42px'}}>

                    {item == null && items &&

                        <div className={"gallery-list"}>
                            {
                                items.map(
                                    (it, index) =>
                                        <div key={index} className={"gallery"} onClick={() => setItem(it)}>
                                            <img style={{width: '130px', height: '130px'}}
                                                src={"/assets/Images/icon_gallery.svg"} alt='dsfds' />
                                            <div className={"label"}>
                                                {it.name}
                                            </div>
                                        </div>
                                    // <Cards images={item.image} title={item.title}
                                    //        moreLink={item.link}
                                    //        width={{xs: '128px', xxs: '152px', md: '300px'}}
                                    //        height={{xs: '212px', md: '420px'}} state={{xs: true, md: false}}
                                    //        font={{xs: 500, md: 900}} variants={'h3'}
                                    //        TranslateId={item.TranslateId}
                                    // />
                                )

                            }
                            {items.length === 0 && <div className={"alert alert-info"} style={{fontSize: '20px'}}>
                                {$t({id: 'emptyGallery'})} !
                            </div>}
                        </div>

                    }

                    {item != null &&
                        <>
                            <div className={"gallery-list"}>
                                {
                                    item && item.items.map(
                                        (it, i) =>
                                            <>
                                                <div key={i} data-x={i} className={"gallery"} onClick={() => window.open(window.location.href = "/gallery/" + item.id + "/" + it.id + ".png", '_blank').focus()}>
                                                    <img style={{width: '130px', height: '130px'}}
                                                        src={"/gallery/" + item.id + "/" + it.id + ".png"} alt={it.name} />
                                                    <div className={"label"}>
                                                        {it.name}
                                                    </div>
                                                </div>
                                                {i % 5 === 0 && <div style={{clear: 'both'}}></div>}
                                            </>
                                    )
                                }
                            </div>
                            {item && item.items.length === 0 &&
                                <div className={"alert alert-info"} style={{fontSize: "20px", padding: "20px"}}>
                                    {$t({id: 'emptyGallery'})} !
                                </div>}
                            <br />
                            <br />
                            <button style={{cursor: "pointer"}} className={"btn btn-success"} onClick={() => setItem(null)}>بازگشت
                                به گالری</button>
                        </>

                    }
                </Grid>
            </Grid>
        </Grid>
    );
};
export default Gallery;
